import classNames from 'classnames'
import { DeepPartial } from 'utility-types'
import InStockL2Heading from '../Stocks/Pages/InStockDetailPageV2/InL2Heading'
import { ManagementTeam } from '../Stocks/Widgets/types'
import Text from '@/stories/components/Common/NewText'

type Tprops = {
  management_team: DeepPartial<ManagementTeam>
  companyName?: string
}
export default function CatalogueManagementTeam({
  management_team,
  companyName,
}: Tprops) {
  return (
    <div>
      <InStockL2Heading heading={`Key Management of ${companyName}`} />

      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="border-b-1 border-grey-tertiary ">
              {!!management_team?.header?.length &&
                management_team.header.map((header, index) => (
                  <th
                    key={header.id}
                    className={classNames(
                      ' text-grey min-w-[200px] max-w-[200px] py-2 font-normal',
                      {
                        'text-right': index,
                        'text-left': !index,
                      },
                    )}
                  >
                    <Text appearance="caption">{header.label}</Text>
                  </th>
                ))}
            </tr>
          </thead>
          <tbody>
            {!!management_team?.rows?.length &&
              management_team.rows.map((officer, index) => (
                <tr
                  key={index}
                  className="border-b-1 border-grey-tertiary last:border-none "
                >
                  {!!management_team.header?.length &&
                    management_team.header.map((header, index) => (
                      <td
                        key={header.id}
                        className={classNames(
                          'min-w-[200px] max-w-[200px] py-3',
                          {
                            'text-right': index,
                            'text-left': !index,
                          },
                        )}
                      >
                        <Text appearance="body1">
                          {header?.id && officer[header.id]
                            ? officer[header.id]
                            : ''}
                        </Text>
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </div>
  )
}
